document.addEventListener('DOMContentLoaded', function () {
  var fallbackViews = {
    'galerie': '#galerie-gants',
    'notre-histoire': '#notre-histoire',
    'ambassadeurs': '#ambassadeurs',
    'clubs': '#clubs',
    'contact': '#contact'
  };
  var requestedView = new URLSearchParams(window.location.search).get('view');
  var home = document.querySelector('.kosugk-home');

  if (home && fallbackViews[requestedView]) {
    var requestedSection = home.querySelector(fallbackViews[requestedView]);
    if (requestedSection) {
      Array.prototype.forEach.call(home.children, function (child) {
        child.hidden = !child.contains(requestedSection);
      });
      var galleryFallback = requestedSection.closest('.kosugk-gallery-fallback');
      if (galleryFallback) galleryFallback.hidden = false;
      document.body.classList.add('kosugk-standalone-view');
      document.title = requestedSection.querySelector('h1, h2')
        ? requestedSection.querySelector('h1, h2').textContent.trim() + ' – KOSUGK'
        : document.title;
      window.scrollTo(0, 0);
    }
  }

  document.querySelectorAll('[data-variant-selector]').forEach(function (select) {
    var section = select.closest('.product-section');
    var stockStat = section && section.querySelector('[data-stock-stat]');
    var stockMessage = stockStat && stockStat.querySelector('[data-stock-message]');
    var addButton = select.closest('form') && select.closest('form').querySelector('button[type="submit"]');

    function updateLiveStock() {
      var option = select.options[select.selectedIndex];
      if (!option || !stockStat || !stockMessage) return;

      var available = option.dataset.available === 'true';
      var size = option.dataset.size || option.textContent.split('—')[0].trim();

      stockStat.classList.toggle('is-empty', !available);

      if (!available) {
        stockMessage.textContent = 'Épuisé dans cette taille';
      } else {
        stockMessage.textContent = 'En stock — taille ' + size;
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Ajouter au panier' : 'Épuisé';
      }
    }

    select.addEventListener('change', updateLiveStock);
    updateLiveStock();
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;
    var target = document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    document.querySelectorAll('.mobile-menu[open]').forEach(function (menu) { menu.removeAttribute('open'); });
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  });
  // Galerie KOSUGK V46 — lightbox éditorial, navigation et crédits intacts
  var galleryLightbox = document.querySelector('[data-gallery-lightbox]');
  var galleryLightboxImage = galleryLightbox && galleryLightbox.querySelector('[data-gallery-lightbox-image]');
  var galleryCounter = galleryLightbox && galleryLightbox.querySelector('[data-gallery-counter]');
  var galleryOpeners = Array.prototype.slice.call(document.querySelectorAll('[data-kosugk-gallery] [data-gallery-open]'));
  var galleryIndex = 0;

  function galleryRender(index) {
    if (!galleryLightbox || !galleryLightboxImage || !galleryOpeners.length) return;
    galleryIndex = (index + galleryOpeners.length) % galleryOpeners.length;
    var image = galleryOpeners[galleryIndex].querySelector('img');
    if (!image) return;
    galleryLightboxImage.src = image.currentSrc || image.src;
    galleryLightboxImage.alt = image.alt || 'KOSUGK en match';
    if (galleryCounter) {
      galleryCounter.textContent = String(galleryIndex + 1).padStart(2, '0') + ' / ' + String(galleryOpeners.length).padStart(2, '0');
    }
  }

  function galleryClose() {
    if (!galleryLightbox || galleryLightbox.hidden) return;
    galleryLightbox.hidden = true;
    galleryLightboxImage.removeAttribute('src');
    document.body.classList.remove('gallery-lightbox-open');
  }

  if (galleryLightbox && galleryLightboxImage && galleryOpeners.length) {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-gallery-open]');
      if (opener) {
        var nextIndex = galleryOpeners.indexOf(opener);
        if (nextIndex < 0) return;
        galleryRender(nextIndex);
        galleryLightbox.hidden = false;
        document.body.classList.add('gallery-lightbox-open');
        return;
      }
      if (event.target.closest('[data-gallery-prev]')) { galleryRender(galleryIndex - 1); return; }
      if (event.target.closest('[data-gallery-next]')) { galleryRender(galleryIndex + 1); return; }
      if (event.target.closest('[data-gallery-close]') || event.target === galleryLightbox) galleryClose();
    });
    document.addEventListener('keydown', function (event) {
      if (galleryLightbox.hidden) return;
      if (event.key === 'Escape') galleryClose();
      if (event.key === 'ArrowLeft') galleryRender(galleryIndex - 1);
      if (event.key === 'ArrowRight') galleryRender(galleryIndex + 1);
    });
  }


});
